var stickyNavigation = {
    scrollHandler: function() {
        var self  = this,
        scrollTop = $( window ).scrollTop();

        if ( $( document.body ).hasClass( 'disable-fixed-header' ) ) {
            return;
        }

        if ( scrollTop > 0  ) {
            if ( $( document.body ).hasClass( 'fixed-header' ) === false ) {
                $( document.body ).addClass( 'fixed-header' );
            }
        } else {
            $( document.body ).removeClass( 'fixed-header' );
        }
    },

    init: function() {
        var self = this;

        $( window ).on( 'scroll mousewheel', function() {
            self.scrollHandler();
        } );
    }
};

export { stickyNavigation };